const Inequality01Icon = /*#__PURE__*/ [
  ["path", { d: "M3 20H21", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 16H6.83782C4.45713 16 3.26678 16 3.03483 15.3728C2.80288 14.7455 3.73716 14.0531 5.60572 12.6682L17.3015 4", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export { Inequality01Icon as default };
//# sourceMappingURL=Inequality01Icon.js.map
